/* eslint-disable */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTrialStatus } from './useTrialStatus';
import { resolveHelpIconStatus } from './useTrialStatus/constants';

import useGetCurrentCompany from '@/queries/company/useGetCurrentCompany';
/**
 * Fills data into a url with [ID] templates. IDs are based on login scope, not currently managing.
 * @param {{url: string}} param0 url : the url that need to be changed
 * @returns rewrittenURL : URL with filled IDs, isLoading: indicator if it's still loading data or not.
 *
 */
export default function useURLRewrite({ url }) {
    const [rewrittenURL, setRewrittenURL] = useState(''); //URL after being rewritten
    //redux data fetch
    const {
        originPartner, // partner ID based on login
        username: email, //email
        firstName,
        lastName,
        id: userID,
        companyID, //company ID based on login
    } = useSelector((state) => state.login);
    const [statusAction, setStatusAction] = useState('');
    const { trialStatus, setTrialStatus } = useTrialStatus();

    const [idLookup, setIdLookup] = useState({
        COMPANY_ID: companyID,
        PARTNER_ID: originPartner,
        USER_ID: userID,
        COMPANY_NAME: '',
        COMPANY_LEGAL_ENTITY_NAME: '',
        USER_EMAIL: email,
        USER_FIRST_NAME: firstName,
        USER_LAST_NAME: lastName,
        COMPANY_ATTR_1: '',
        COMPANY_ATTR_2: '',
        COMPANY_ATTR_3: '',
        TRIAL_STATUS: '',
        /* PARTNER_NAME: '',
        PARTNER_LEGAL_ENTITY_NAME: '',
        PARTNER_COMPANY_ATTR_1: '',
        PARTNER_COMPANY_ATTR_2: '',
        PARTNER_COMPANY_ATTR_3: '',
        PARTNER_PARTNER_ATTR_1: '',
        PARTNER_PARTNER_ATTR_2: '',
        PARTNER_PARTNER_ATTR_3: '',*/
    }); //IDs lookup, please add more as we go. IDs are based on login scope, not currently managing.

    const { currentCompany } = useSelector((state) => state.navigationLists);
    const { data: currentCompanyData } = useGetCurrentCompany();

    //get logged-in company's data
    const handleCompanyData = async () => {
        try {
            const {
                attribute1,
                attribute2,
                attribute3,
                name,
                entityName,
                approved,
                isTrial,
                trialHold,
                isActive,
                status,
                partnerID,
            } = currentCompanyData;

            const isActiveCompany = isActive && status !== 20;
            const isApproved = approved && status !== 3;

            // Determine help icon colour from managed company lifecycle state.
            const newStatusAction = resolveHelpIconStatus({
                isActive: isActiveCompany,
                approved: isApproved,
                isTrial,
                trialHold,
                partnerID,
            });

            setStatusAction(newStatusAction);

            const newLookup = {
                ...idLookup,
                COMPANY_ID: companyID,
                COMPANY_ATTR_1: attribute1 || '',
                COMPANY_ATTR_2: attribute2 || '',
                COMPANY_ATTR_3: attribute3 || '',
                COMPANY_NAME: name || '',
                COMPANY_LEGAL_ENTITY_NAME: entityName || '',
            };
            setIdLookup(newLookup);
        } catch (e) {
            console.log('could not fetch company data on URL Rewrite', { e });
        }
    };

    useEffect(() => {
        if (currentCompanyData) {
            handleCompanyData();
        }
    }, [currentCompanyData]);

    useEffect(() => {
        if (statusAction) {
            setTrialStatus({ type: statusAction });
        }
    }, [statusAction]);

    useEffect(() => {
        // NOTE: force update idLookup when trialStatus changes as cant get it from login
        setIdLookup((p) => ({
            ...p,
            TRIAL_STATUS: trialStatus.status,
        }));
    }, [trialStatus]);

    //process URLs whenever it changes
    useEffect(() => {
        rewriteURL();
    }, [
        companyID,
        originPartner,
        idLookup,
        userID,
        email,
        firstName,
        lastName,
        url,
    ]);

    //fills URL with relevant IDs data
    const rewriteURL = () => {
        let newURL = url || '';
        Object.entries(idLookup).forEach(([token, actualData]) => {
            newURL = newURL.replaceAll(`[${token}]`, actualData);
        });
        setRewrittenURL(newURL);
    };

    return { rewrittenURL, trialStatus };
}
